import { render, staticRenderFns } from "./Iade.vue?vue&type=template&id=8b9e3340"
import script from "./Iade.vue?vue&type=script&lang=js"
export * from "./Iade.vue?vue&type=script&lang=js"
import style0 from "./Iade.vue?vue&type=style&index=0&id=8b9e3340&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports